<template>
  <button class="language-list-card" @click="destinationSelected(item)">
    <span
      class="language-list-card-label"
      v-html="parsedLanguageLabel ? parsedLanguageLabel : item.label"
    />
    <span v-if="isSelecting" class="icon-loading-black"></span>
    <span v-else-if="localValue" class="language-list-card-icon icon-checkmark-circle"></span>
  </button>
</template>

<script>
import { mapState } from 'vuex'
import { highlightMatch } from '@utils/highlight-match'

export default {
  name: 'language-list-card',
  props: {
    item: {
      type: Object
    },
    searchInput: {
      type: String,
      default: ''
    },
    queryChanged: {
      type: Number,
      default: -1
    },
    selectedLanguage: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    searchString: '',
    isSelecting: false
  }),
  computed: {
    ...mapState('auth', ['isUpdateProfilePending']),
    localValue() {
      return this.selectedLanguage === this.item.value ? this.item.value : ''
    },
    parsedLanguageLabel: {
      get() {
        return highlightMatch(this.searchString, this.item.label, 'bold-highlighted')
      },
      set(newValue) {
        this.searchString = newValue
      }
    }
  },
  watch: {
    searchInput(val) {
      if (val) {
        this.searchString = val
      } else {
        this.searchString = ''
      }
    },
    async queryChanged() {
      this.searchString = this.searchInput
    },
    isUpdateProfilePending(val) {
      if (!val) {
        this.isSelecting = false
      }
    }
  },
  methods: {
    destinationSelected(item) {
      this.isSelecting = true
      this.$emit('destination-selected', item)
    }
  }
}
</script>
